module.exports = __webpack_public_path__ + "img/39.53ba7c0c.png";